var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container copyright position-absolute"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 pl-4"},[_c('small',[_vm._v("\n        ©2014-"+_vm._s(new Date().getFullYear())+" "),_c('br'),_vm._v("\n        All Rights Reserved. "),_c('br'),_vm._v("\n        Version: 1.0.0\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }